<div class="languagePopup">
  <div class="titleContainer">
    Choose your language/ Choisissez votre langue
  </div>

  <div class="languageSelectionBox">
    <div class="LanguageContainer">
      <h1 class="LanguageSelectionText" (click)="setLang('fr')">FR</h1>
    </div>
    <div class="LanguageContainer">
      <h1 class="LanguageSelectionText" (click)="setLang('en')">EN</h1>
    </div>
  </div>
</div>